import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

const TONE = {
  brand: "text-brand",
  muted: "text-tertiary",
  inherit: undefined,
};

export function Eyebrow({
  as: Tag = "p",
  tone = "brand",
  children,
}: {
  as?: "p" | "h2";
  tone?: keyof typeof TONE;
  children: ReactNode;
}) {
  return (
    <Tag
      className={cn(
        "font-mono text-xs uppercase leading-relaxed tracking-caps",
        TONE[tone],
      )}
    >
      {children}
    </Tag>
  );
}
